import React from "react";
import styles from "./AvailabilitySelectionModule.module.css";
import BookingInfo from "./components/BookingInfo.component";
import AvailabilitySelector from "./components/AvailabilitySelector.component";
import { MentorCheckoutInfo } from "./AvailabilitySelectionModule.machine";

interface AvailabilitySelectioViewProps {
  mentor_info: MentorCheckoutInfo;
  duration: 30 | 60;
  pages: string[][];
  toggleDuration: () => void;
  state: "paginating" | "start" | "last" | "expanded";
  increment: () => void;
  decrement: () => void;
  expanded_index: number;
  toggleExpand: (index: number) => void;
  selectSlot: (datetime: string) => void;
}

const AvailabilitySelectionView = ({
  mentor_info,
  duration,
  toggleDuration,
  pages,
  state,
  increment,
  decrement,
  expanded_index,
  toggleExpand,
  selectSlot,
}: AvailabilitySelectioViewProps) => {
  const price = duration === 30 ? mentor_info.cost / 2 : mentor_info.cost;

  return (
    <div className={styles.container}>
      <BookingInfo
        mentor_info={mentor_info}
        duration={duration}
        price={price}
        toggleDuration={toggleDuration}
      />
      <AvailabilitySelector
        pages={pages}
        state={state}
        increment={increment}
        decrement={decrement}
        expanded_index={expanded_index}
        toggleExpand={toggleExpand}
        selectSlot={selectSlot}
      />
    </div>
  );
};

export default AvailabilitySelectionView;
